/*
 * @Author: your name
 * @Date: 2021-10-22 10:54:26
 * @LastEditTime: 2023-01-04 09:34:10
 * @LastEditors: chenting chenting@cqliving.com
 * @Description: In User Settings Edit
 * @FilePath: \share-news-detail-pages\src\common\dataCollect.ts
 */
import {
  dataCollect,
  getHlxDataSwitch,
  getHlxDataSwitch2,
  getHlxNewsRecord,
  getHlxNewsRecordTime
} from "@/api/dataCollect/index";
import store from "@/store";
import Fingerprint2 from "fingerprintjs2";
let baseData = {
  appId: "",
  appType: 0,
  appVersion: "",
  classifyId: "",
  source: 2,
  sourceId: "",
  sourceType: 1,
  token: "",
  url: window.location.href,
  userTag: ""
};
let isHlx: boolean = true;
try {
  isUsehlx();
} catch (error) {
  console.log(error);
}
// 基础数据获取
function base(newsList: any) {
  baseData.classifyId = newsList.classifyId || newsList.infoClassifyId;
  baseData.appId = newsList.appId;
  baseData.sourceId = newsList.informationId
    ? newsList.informationId
    : newsList.id;
  baseData.appType = appType();
  //获取当前页面地址
  baseData.url = window.location.href;
  if (ZWY_CLOUD.isOpenInApp()) {
    const userInfoObj = ZWY_CLOUD.getUserInfo();
    if (userInfoObj.token) {
      baseData.token = userInfoObj.token;
    }
  }
  return baseData;
}
// 是否是微信
function isWeixn() {
  const ua = window.navigator.userAgent.toLowerCase();
  const isWeixin = ua.indexOf("micromessenger") != -1;
  if (isWeixin) {
    return true;
  } else {
    return false;
  }
}
// 当前appType是什么
function appType() {
  // 客户端类型{1:1+39APP，2，微信，3：其他浏览器，4:QQ,5:QQ空间,6:微博}
  if (ZWY_CLOUD.isOpenInApp()) {
    return 1;
  } else {
    if (isWeixn()) {
      return 2;
    } else {
      const ua = window.navigator.userAgent.toLowerCase();
      if (ua.indexOf(" qq") > -1 && ua.indexOf("mqqbrowser") < 0) {
        return 4;
      } else {
        return 3;
      }
    }
  }
}
// 浏览记录  加载结束
export function getData(startTime: string, endTime: string, news: any) {
  let isApp;
  if (ZWY_CLOUD.isOpenInApp()) {
    isApp = 1;
  } else {
    isApp = 0;
  }
  base(news);
  const par = {
    browseLogDtos: [baseData],
    loadDto: [
      {
        classifyId: news.classifyId || news.infoClassifyId,
        endTime: endTime,
        inTime: startTime,
        sourceId: news.informationId,
        sourceType: 2,
        token: isApp ? ZWY_CLOUD.getUserInfo().token : ""
      }
    ]
  };
  // try {
  //   dataCollect(par);
  // } catch (error) {
  //   console.log(error);
  // }
  try {
    if (isHlx) {
      isUsehlxRecord(news);
    }
  } catch (error) {
    console.log(error);
  }
}
// 分享
export function shareLogs(news: any) {
  base(news);
  baseData["isSuccess"] = 1;
  baseData["shareMethod"] = 1;
  const par = {
    shareLogs: [baseData]
  };
  try {
    dataCollect(par);
  } catch (error) {
    console.log(error);
  }
}
// 浏览时长
export async function seeTime(times: any) {
  baseData["times"] = times;
  const par = {
    timeDtos: [baseData]
  };
  // try {
  //   dataCollect(par);
  // } catch (error) {
  //   console.log(error);
  // }
  let st;
  if (baseData.sourceType == 1) {
    st = "news";
  }
  if (window.location.href.indexOf("askgov") != -1) {
    st = "wz";
  }

  try {
    if (isHlx) {
      getHlxNewsRecordTime({
        app_id: baseData.appId, // 请求源APP_ID
        source_id: baseData.sourceId, // 业务源ID，新闻就是新闻列表表id（info_classify_id）
        source_type: st, // 业务源类型{news:新闻,wz:问政,shop:商情,shoot:随手拍,joke:段子,act:活动,topic:话题,moments:发现}
        url: baseData.url, // 	页面请求地址
        times: parseInt(times), // 浏览时长
        end_source: ZWY_CLOUD.isOpenInApp() ? "app" : "H5",
        token: store.state.token,
        session_id: store.state.sessionId
          ? store.state.sessionId
          : await getMurmur()
      });
    }
  } catch (error) {
    console.log(error);
  }
}

// 今天当前页面关闭
// export function isHiddenTime() {
//   let st: any;
//   document.addEventListener("visibilitychange", e => {
//     if (document.hidden) {
//       document.title = "1111";
//       let t: any = time();
//       baseData["times"] = (Number(t) - Number(st)) / 1000;
//       // seeTime();
//     } else {
//       st = time();
//       document.title = "222";
//     }
//   });
// }

// 获取时间 1时间戳, 2时间
export function time() {
  return new Date().getTime() + "";
}

export async function isUsehlxRecord(news: any) {
  let st;
  if (news.sourceType == 1) {
    st = "news";
  }
  if (window.location.href.indexOf("askgov") != -1) {
    st = "wz";
  }
  let par = {
    app_id: news.appId, // 请求源APP_ID
    source_id: news.infoClassifyId ? news.infoClassifyId : news.id, // 业务源ID，新闻就是新闻列表表id（info_classify_id）
    source_type: st, // 业务源类型{news:新闻,wz:问政,shop:商情,shoot:随手拍,joke:段子,act:活动,topic:话题,moments:发现}
    url: news.url, // 	页面请求地址
    send_source: ZWY_CLOUD.isOpenInApp() ? "app" : "H5",
    token: store.state.token,
    session_id: store.state.sessionId
      ? store.state.sessionId
      : await getMurmur()
  };
  try {
    getHlxNewsRecord(par);
  } catch (error) {
    console.log(error);
  }
}

export async function isUsehlx() {
  let res = await getHlxDataSwitch();
  if ((res as any) == "on" || res.data.data == "on") {
    isHlx = true;
  } else {
    isHlx = false;
  }
  // res.data.data == "on" ? (isHlx = true) : (isHlx = false);
}

export function getMurmur() {
  const options = {
    excludes: {
      userAgent: true,
      audio: true,
      enumerateDevices: true,
      fonts: true,
      fontsFlash: true,
      webgl: true,
      canvas: true
    }
  };
  return new Promise((res, rej) => {
    Fingerprint2.get(options, function(components: any) {
      // 参数
      const values = components.map(function(component: any) {
        return component.value;
      });
      // 指纹
      const murmur = Fingerprint2.x64hash128(values.join(""), 31);
      res(murmur);
    });
  });
}
